var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-lg-4 col-md-6 mb-30" }, [
    _c(
      "a",
      {
        staticClass: "card h-100",
        attrs: { href: "membre?permit_number=" + _vm.member.numeroPermis }
      },
      [
        _c("div", { staticClass: "card-body px-4 pt-4 pb-0" }, [
          _c("h4", { staticClass: "name text-primary" }, [
            _vm._v(_vm._s(_vm.name))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer px-4 pb-4 pt-0" }, [
          _c("div", { staticClass: "row gx-2 align-items-end" }, [
            _c("div", { staticClass: "col-10" }, [
              _c("ul", { staticClass: "list-unstyled mb-0 text-dark" }, [
                _c("li", [
                  _vm._v(
                    "Numéro de permis : " + _vm._s(_vm.member.numeroPermis)
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Statut : " + _vm._s(_vm.member.statut))])
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto ms-auto text-primary d-flex" }, [
      _c("i", { staticClass: "ph-arrow-circle-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }